__turbopack_context__.v({
  "ai-lg-baseline": "IgfSgW_ai-lg-baseline",
  "ai-lg-center": "IgfSgW_ai-lg-center",
  "ai-lg-end": "IgfSgW_ai-lg-end",
  "ai-lg-flex-end": "IgfSgW_ai-lg-flex-end",
  "ai-lg-flex-start": "IgfSgW_ai-lg-flex-start",
  "ai-lg-normal": "IgfSgW_ai-lg-normal",
  "ai-lg-self-end": "IgfSgW_ai-lg-self-end",
  "ai-lg-self-start": "IgfSgW_ai-lg-self-start",
  "ai-lg-start": "IgfSgW_ai-lg-start",
  "ai-lg-stretch": "IgfSgW_ai-lg-stretch",
  "ai-md-baseline": "IgfSgW_ai-md-baseline",
  "ai-md-center": "IgfSgW_ai-md-center",
  "ai-md-end": "IgfSgW_ai-md-end",
  "ai-md-flex-end": "IgfSgW_ai-md-flex-end",
  "ai-md-flex-start": "IgfSgW_ai-md-flex-start",
  "ai-md-normal": "IgfSgW_ai-md-normal",
  "ai-md-self-end": "IgfSgW_ai-md-self-end",
  "ai-md-self-start": "IgfSgW_ai-md-self-start",
  "ai-md-start": "IgfSgW_ai-md-start",
  "ai-md-stretch": "IgfSgW_ai-md-stretch",
  "ai-sm-baseline": "IgfSgW_ai-sm-baseline",
  "ai-sm-center": "IgfSgW_ai-sm-center",
  "ai-sm-end": "IgfSgW_ai-sm-end",
  "ai-sm-flex-end": "IgfSgW_ai-sm-flex-end",
  "ai-sm-flex-start": "IgfSgW_ai-sm-flex-start",
  "ai-sm-normal": "IgfSgW_ai-sm-normal",
  "ai-sm-self-end": "IgfSgW_ai-sm-self-end",
  "ai-sm-self-start": "IgfSgW_ai-sm-self-start",
  "ai-sm-start": "IgfSgW_ai-sm-start",
  "ai-sm-stretch": "IgfSgW_ai-sm-stretch",
  "ai-xl-baseline": "IgfSgW_ai-xl-baseline",
  "ai-xl-center": "IgfSgW_ai-xl-center",
  "ai-xl-end": "IgfSgW_ai-xl-end",
  "ai-xl-flex-end": "IgfSgW_ai-xl-flex-end",
  "ai-xl-flex-start": "IgfSgW_ai-xl-flex-start",
  "ai-xl-normal": "IgfSgW_ai-xl-normal",
  "ai-xl-self-end": "IgfSgW_ai-xl-self-end",
  "ai-xl-self-start": "IgfSgW_ai-xl-self-start",
  "ai-xl-start": "IgfSgW_ai-xl-start",
  "ai-xl-stretch": "IgfSgW_ai-xl-stretch",
  "grid": "IgfSgW_grid",
  "grid-af-lg--moz-initial": "IgfSgW_grid-af-lg--moz-initial",
  "grid-af-lg-column": "IgfSgW_grid-af-lg-column",
  "grid-af-lg-dense": "IgfSgW_grid-af-lg-dense",
  "grid-af-lg-inherit": "IgfSgW_grid-af-lg-inherit",
  "grid-af-lg-initial": "IgfSgW_grid-af-lg-initial",
  "grid-af-lg-revert": "IgfSgW_grid-af-lg-revert",
  "grid-af-lg-row": "IgfSgW_grid-af-lg-row",
  "grid-af-lg-unset": "IgfSgW_grid-af-lg-unset",
  "grid-af-md--moz-initial": "IgfSgW_grid-af-md--moz-initial",
  "grid-af-md-column": "IgfSgW_grid-af-md-column",
  "grid-af-md-dense": "IgfSgW_grid-af-md-dense",
  "grid-af-md-inherit": "IgfSgW_grid-af-md-inherit",
  "grid-af-md-initial": "IgfSgW_grid-af-md-initial",
  "grid-af-md-revert": "IgfSgW_grid-af-md-revert",
  "grid-af-md-row": "IgfSgW_grid-af-md-row",
  "grid-af-md-unset": "IgfSgW_grid-af-md-unset",
  "grid-af-sm--moz-initial": "IgfSgW_grid-af-sm--moz-initial",
  "grid-af-sm-column": "IgfSgW_grid-af-sm-column",
  "grid-af-sm-dense": "IgfSgW_grid-af-sm-dense",
  "grid-af-sm-inherit": "IgfSgW_grid-af-sm-inherit",
  "grid-af-sm-initial": "IgfSgW_grid-af-sm-initial",
  "grid-af-sm-revert": "IgfSgW_grid-af-sm-revert",
  "grid-af-sm-row": "IgfSgW_grid-af-sm-row",
  "grid-af-sm-unset": "IgfSgW_grid-af-sm-unset",
  "grid-af-xl--moz-initial": "IgfSgW_grid-af-xl--moz-initial",
  "grid-af-xl-column": "IgfSgW_grid-af-xl-column",
  "grid-af-xl-dense": "IgfSgW_grid-af-xl-dense",
  "grid-af-xl-inherit": "IgfSgW_grid-af-xl-inherit",
  "grid-af-xl-initial": "IgfSgW_grid-af-xl-initial",
  "grid-af-xl-revert": "IgfSgW_grid-af-xl-revert",
  "grid-af-xl-row": "IgfSgW_grid-af-xl-row",
  "grid-af-xl-unset": "IgfSgW_grid-af-xl-unset",
  "grid-columns-lg-1": "IgfSgW_grid-columns-lg-1",
  "grid-columns-lg-10": "IgfSgW_grid-columns-lg-10",
  "grid-columns-lg-11": "IgfSgW_grid-columns-lg-11",
  "grid-columns-lg-12": "IgfSgW_grid-columns-lg-12",
  "grid-columns-lg-2": "IgfSgW_grid-columns-lg-2",
  "grid-columns-lg-3": "IgfSgW_grid-columns-lg-3",
  "grid-columns-lg-4": "IgfSgW_grid-columns-lg-4",
  "grid-columns-lg-5": "IgfSgW_grid-columns-lg-5",
  "grid-columns-lg-6": "IgfSgW_grid-columns-lg-6",
  "grid-columns-lg-7": "IgfSgW_grid-columns-lg-7",
  "grid-columns-lg-8": "IgfSgW_grid-columns-lg-8",
  "grid-columns-lg-9": "IgfSgW_grid-columns-lg-9",
  "grid-columns-md-1": "IgfSgW_grid-columns-md-1",
  "grid-columns-md-10": "IgfSgW_grid-columns-md-10",
  "grid-columns-md-11": "IgfSgW_grid-columns-md-11",
  "grid-columns-md-12": "IgfSgW_grid-columns-md-12",
  "grid-columns-md-2": "IgfSgW_grid-columns-md-2",
  "grid-columns-md-3": "IgfSgW_grid-columns-md-3",
  "grid-columns-md-4": "IgfSgW_grid-columns-md-4",
  "grid-columns-md-5": "IgfSgW_grid-columns-md-5",
  "grid-columns-md-6": "IgfSgW_grid-columns-md-6",
  "grid-columns-md-7": "IgfSgW_grid-columns-md-7",
  "grid-columns-md-8": "IgfSgW_grid-columns-md-8",
  "grid-columns-md-9": "IgfSgW_grid-columns-md-9",
  "grid-columns-sm-1": "IgfSgW_grid-columns-sm-1",
  "grid-columns-sm-10": "IgfSgW_grid-columns-sm-10",
  "grid-columns-sm-11": "IgfSgW_grid-columns-sm-11",
  "grid-columns-sm-12": "IgfSgW_grid-columns-sm-12",
  "grid-columns-sm-2": "IgfSgW_grid-columns-sm-2",
  "grid-columns-sm-3": "IgfSgW_grid-columns-sm-3",
  "grid-columns-sm-4": "IgfSgW_grid-columns-sm-4",
  "grid-columns-sm-5": "IgfSgW_grid-columns-sm-5",
  "grid-columns-sm-6": "IgfSgW_grid-columns-sm-6",
  "grid-columns-sm-7": "IgfSgW_grid-columns-sm-7",
  "grid-columns-sm-8": "IgfSgW_grid-columns-sm-8",
  "grid-columns-sm-9": "IgfSgW_grid-columns-sm-9",
  "grid-columns-xl-1": "IgfSgW_grid-columns-xl-1",
  "grid-columns-xl-10": "IgfSgW_grid-columns-xl-10",
  "grid-columns-xl-11": "IgfSgW_grid-columns-xl-11",
  "grid-columns-xl-12": "IgfSgW_grid-columns-xl-12",
  "grid-columns-xl-2": "IgfSgW_grid-columns-xl-2",
  "grid-columns-xl-3": "IgfSgW_grid-columns-xl-3",
  "grid-columns-xl-4": "IgfSgW_grid-columns-xl-4",
  "grid-columns-xl-5": "IgfSgW_grid-columns-xl-5",
  "grid-columns-xl-6": "IgfSgW_grid-columns-xl-6",
  "grid-columns-xl-7": "IgfSgW_grid-columns-xl-7",
  "grid-columns-xl-8": "IgfSgW_grid-columns-xl-8",
  "grid-columns-xl-9": "IgfSgW_grid-columns-xl-9",
  "grid-gap-lg-1": "IgfSgW_grid-gap-lg-1",
  "grid-gap-lg-10": "IgfSgW_grid-gap-lg-10",
  "grid-gap-lg-11": "IgfSgW_grid-gap-lg-11",
  "grid-gap-lg-12": "IgfSgW_grid-gap-lg-12",
  "grid-gap-lg-13": "IgfSgW_grid-gap-lg-13",
  "grid-gap-lg-14": "IgfSgW_grid-gap-lg-14",
  "grid-gap-lg-2": "IgfSgW_grid-gap-lg-2",
  "grid-gap-lg-3": "IgfSgW_grid-gap-lg-3",
  "grid-gap-lg-4": "IgfSgW_grid-gap-lg-4",
  "grid-gap-lg-5": "IgfSgW_grid-gap-lg-5",
  "grid-gap-lg-6": "IgfSgW_grid-gap-lg-6",
  "grid-gap-lg-7": "IgfSgW_grid-gap-lg-7",
  "grid-gap-lg-8": "IgfSgW_grid-gap-lg-8",
  "grid-gap-lg-9": "IgfSgW_grid-gap-lg-9",
  "grid-gap-md-1": "IgfSgW_grid-gap-md-1",
  "grid-gap-md-10": "IgfSgW_grid-gap-md-10",
  "grid-gap-md-11": "IgfSgW_grid-gap-md-11",
  "grid-gap-md-12": "IgfSgW_grid-gap-md-12",
  "grid-gap-md-13": "IgfSgW_grid-gap-md-13",
  "grid-gap-md-14": "IgfSgW_grid-gap-md-14",
  "grid-gap-md-2": "IgfSgW_grid-gap-md-2",
  "grid-gap-md-3": "IgfSgW_grid-gap-md-3",
  "grid-gap-md-4": "IgfSgW_grid-gap-md-4",
  "grid-gap-md-5": "IgfSgW_grid-gap-md-5",
  "grid-gap-md-6": "IgfSgW_grid-gap-md-6",
  "grid-gap-md-7": "IgfSgW_grid-gap-md-7",
  "grid-gap-md-8": "IgfSgW_grid-gap-md-8",
  "grid-gap-md-9": "IgfSgW_grid-gap-md-9",
  "grid-gap-sm-1": "IgfSgW_grid-gap-sm-1",
  "grid-gap-sm-10": "IgfSgW_grid-gap-sm-10",
  "grid-gap-sm-11": "IgfSgW_grid-gap-sm-11",
  "grid-gap-sm-12": "IgfSgW_grid-gap-sm-12",
  "grid-gap-sm-13": "IgfSgW_grid-gap-sm-13",
  "grid-gap-sm-14": "IgfSgW_grid-gap-sm-14",
  "grid-gap-sm-2": "IgfSgW_grid-gap-sm-2",
  "grid-gap-sm-3": "IgfSgW_grid-gap-sm-3",
  "grid-gap-sm-4": "IgfSgW_grid-gap-sm-4",
  "grid-gap-sm-5": "IgfSgW_grid-gap-sm-5",
  "grid-gap-sm-6": "IgfSgW_grid-gap-sm-6",
  "grid-gap-sm-7": "IgfSgW_grid-gap-sm-7",
  "grid-gap-sm-8": "IgfSgW_grid-gap-sm-8",
  "grid-gap-sm-9": "IgfSgW_grid-gap-sm-9",
  "grid-gap-xl-1": "IgfSgW_grid-gap-xl-1",
  "grid-gap-xl-10": "IgfSgW_grid-gap-xl-10",
  "grid-gap-xl-11": "IgfSgW_grid-gap-xl-11",
  "grid-gap-xl-12": "IgfSgW_grid-gap-xl-12",
  "grid-gap-xl-13": "IgfSgW_grid-gap-xl-13",
  "grid-gap-xl-14": "IgfSgW_grid-gap-xl-14",
  "grid-gap-xl-2": "IgfSgW_grid-gap-xl-2",
  "grid-gap-xl-3": "IgfSgW_grid-gap-xl-3",
  "grid-gap-xl-4": "IgfSgW_grid-gap-xl-4",
  "grid-gap-xl-5": "IgfSgW_grid-gap-xl-5",
  "grid-gap-xl-6": "IgfSgW_grid-gap-xl-6",
  "grid-gap-xl-7": "IgfSgW_grid-gap-xl-7",
  "grid-gap-xl-8": "IgfSgW_grid-gap-xl-8",
  "grid-gap-xl-9": "IgfSgW_grid-gap-xl-9",
  "grid-height-lg-1": "IgfSgW_grid-height-lg-1",
  "grid-height-lg-10": "IgfSgW_grid-height-lg-10",
  "grid-height-lg-11": "IgfSgW_grid-height-lg-11",
  "grid-height-lg-12": "IgfSgW_grid-height-lg-12",
  "grid-height-lg-13": "IgfSgW_grid-height-lg-13",
  "grid-height-lg-14": "IgfSgW_grid-height-lg-14",
  "grid-height-lg-2": "IgfSgW_grid-height-lg-2",
  "grid-height-lg-3": "IgfSgW_grid-height-lg-3",
  "grid-height-lg-4": "IgfSgW_grid-height-lg-4",
  "grid-height-lg-5": "IgfSgW_grid-height-lg-5",
  "grid-height-lg-6": "IgfSgW_grid-height-lg-6",
  "grid-height-lg-7": "IgfSgW_grid-height-lg-7",
  "grid-height-lg-8": "IgfSgW_grid-height-lg-8",
  "grid-height-lg-9": "IgfSgW_grid-height-lg-9",
  "grid-height-md-1": "IgfSgW_grid-height-md-1",
  "grid-height-md-10": "IgfSgW_grid-height-md-10",
  "grid-height-md-11": "IgfSgW_grid-height-md-11",
  "grid-height-md-12": "IgfSgW_grid-height-md-12",
  "grid-height-md-13": "IgfSgW_grid-height-md-13",
  "grid-height-md-14": "IgfSgW_grid-height-md-14",
  "grid-height-md-2": "IgfSgW_grid-height-md-2",
  "grid-height-md-3": "IgfSgW_grid-height-md-3",
  "grid-height-md-4": "IgfSgW_grid-height-md-4",
  "grid-height-md-5": "IgfSgW_grid-height-md-5",
  "grid-height-md-6": "IgfSgW_grid-height-md-6",
  "grid-height-md-7": "IgfSgW_grid-height-md-7",
  "grid-height-md-8": "IgfSgW_grid-height-md-8",
  "grid-height-md-9": "IgfSgW_grid-height-md-9",
  "grid-height-sm-1": "IgfSgW_grid-height-sm-1",
  "grid-height-sm-10": "IgfSgW_grid-height-sm-10",
  "grid-height-sm-11": "IgfSgW_grid-height-sm-11",
  "grid-height-sm-12": "IgfSgW_grid-height-sm-12",
  "grid-height-sm-13": "IgfSgW_grid-height-sm-13",
  "grid-height-sm-14": "IgfSgW_grid-height-sm-14",
  "grid-height-sm-2": "IgfSgW_grid-height-sm-2",
  "grid-height-sm-3": "IgfSgW_grid-height-sm-3",
  "grid-height-sm-4": "IgfSgW_grid-height-sm-4",
  "grid-height-sm-5": "IgfSgW_grid-height-sm-5",
  "grid-height-sm-6": "IgfSgW_grid-height-sm-6",
  "grid-height-sm-7": "IgfSgW_grid-height-sm-7",
  "grid-height-sm-8": "IgfSgW_grid-height-sm-8",
  "grid-height-sm-9": "IgfSgW_grid-height-sm-9",
  "grid-height-xl-1": "IgfSgW_grid-height-xl-1",
  "grid-height-xl-10": "IgfSgW_grid-height-xl-10",
  "grid-height-xl-11": "IgfSgW_grid-height-xl-11",
  "grid-height-xl-12": "IgfSgW_grid-height-xl-12",
  "grid-height-xl-13": "IgfSgW_grid-height-xl-13",
  "grid-height-xl-14": "IgfSgW_grid-height-xl-14",
  "grid-height-xl-2": "IgfSgW_grid-height-xl-2",
  "grid-height-xl-3": "IgfSgW_grid-height-xl-3",
  "grid-height-xl-4": "IgfSgW_grid-height-xl-4",
  "grid-height-xl-5": "IgfSgW_grid-height-xl-5",
  "grid-height-xl-6": "IgfSgW_grid-height-xl-6",
  "grid-height-xl-7": "IgfSgW_grid-height-xl-7",
  "grid-height-xl-8": "IgfSgW_grid-height-xl-8",
  "grid-height-xl-9": "IgfSgW_grid-height-xl-9",
  "grid-ta-lg-center": "IgfSgW_grid-ta-lg-center",
  "grid-ta-lg-end": "IgfSgW_grid-ta-lg-end",
  "grid-ta-lg-justify": "IgfSgW_grid-ta-lg-justify",
  "grid-ta-lg-left": "IgfSgW_grid-ta-lg-left",
  "grid-ta-lg-match-parent": "IgfSgW_grid-ta-lg-match-parent",
  "grid-ta-lg-right": "IgfSgW_grid-ta-lg-right",
  "grid-ta-lg-start": "IgfSgW_grid-ta-lg-start",
  "grid-ta-md-center": "IgfSgW_grid-ta-md-center",
  "grid-ta-md-end": "IgfSgW_grid-ta-md-end",
  "grid-ta-md-justify": "IgfSgW_grid-ta-md-justify",
  "grid-ta-md-left": "IgfSgW_grid-ta-md-left",
  "grid-ta-md-match-parent": "IgfSgW_grid-ta-md-match-parent",
  "grid-ta-md-right": "IgfSgW_grid-ta-md-right",
  "grid-ta-md-start": "IgfSgW_grid-ta-md-start",
  "grid-ta-sm-center": "IgfSgW_grid-ta-sm-center",
  "grid-ta-sm-end": "IgfSgW_grid-ta-sm-end",
  "grid-ta-sm-justify": "IgfSgW_grid-ta-sm-justify",
  "grid-ta-sm-left": "IgfSgW_grid-ta-sm-left",
  "grid-ta-sm-match-parent": "IgfSgW_grid-ta-sm-match-parent",
  "grid-ta-sm-right": "IgfSgW_grid-ta-sm-right",
  "grid-ta-sm-start": "IgfSgW_grid-ta-sm-start",
  "grid-ta-xl-center": "IgfSgW_grid-ta-xl-center",
  "grid-ta-xl-end": "IgfSgW_grid-ta-xl-end",
  "grid-ta-xl-justify": "IgfSgW_grid-ta-xl-justify",
  "grid-ta-xl-left": "IgfSgW_grid-ta-xl-left",
  "grid-ta-xl-match-parent": "IgfSgW_grid-ta-xl-match-parent",
  "grid-ta-xl-right": "IgfSgW_grid-ta-xl-right",
  "grid-ta-xl-start": "IgfSgW_grid-ta-xl-start",
  "grid-width-lg-1": "IgfSgW_grid-width-lg-1",
  "grid-width-lg-10": "IgfSgW_grid-width-lg-10",
  "grid-width-lg-11": "IgfSgW_grid-width-lg-11",
  "grid-width-lg-12": "IgfSgW_grid-width-lg-12",
  "grid-width-lg-13": "IgfSgW_grid-width-lg-13",
  "grid-width-lg-14": "IgfSgW_grid-width-lg-14",
  "grid-width-lg-2": "IgfSgW_grid-width-lg-2",
  "grid-width-lg-3": "IgfSgW_grid-width-lg-3",
  "grid-width-lg-4": "IgfSgW_grid-width-lg-4",
  "grid-width-lg-5": "IgfSgW_grid-width-lg-5",
  "grid-width-lg-6": "IgfSgW_grid-width-lg-6",
  "grid-width-lg-7": "IgfSgW_grid-width-lg-7",
  "grid-width-lg-8": "IgfSgW_grid-width-lg-8",
  "grid-width-lg-9": "IgfSgW_grid-width-lg-9",
  "grid-width-md-1": "IgfSgW_grid-width-md-1",
  "grid-width-md-10": "IgfSgW_grid-width-md-10",
  "grid-width-md-11": "IgfSgW_grid-width-md-11",
  "grid-width-md-12": "IgfSgW_grid-width-md-12",
  "grid-width-md-13": "IgfSgW_grid-width-md-13",
  "grid-width-md-14": "IgfSgW_grid-width-md-14",
  "grid-width-md-2": "IgfSgW_grid-width-md-2",
  "grid-width-md-3": "IgfSgW_grid-width-md-3",
  "grid-width-md-4": "IgfSgW_grid-width-md-4",
  "grid-width-md-5": "IgfSgW_grid-width-md-5",
  "grid-width-md-6": "IgfSgW_grid-width-md-6",
  "grid-width-md-7": "IgfSgW_grid-width-md-7",
  "grid-width-md-8": "IgfSgW_grid-width-md-8",
  "grid-width-md-9": "IgfSgW_grid-width-md-9",
  "grid-width-sm-1": "IgfSgW_grid-width-sm-1",
  "grid-width-sm-10": "IgfSgW_grid-width-sm-10",
  "grid-width-sm-11": "IgfSgW_grid-width-sm-11",
  "grid-width-sm-12": "IgfSgW_grid-width-sm-12",
  "grid-width-sm-13": "IgfSgW_grid-width-sm-13",
  "grid-width-sm-14": "IgfSgW_grid-width-sm-14",
  "grid-width-sm-2": "IgfSgW_grid-width-sm-2",
  "grid-width-sm-3": "IgfSgW_grid-width-sm-3",
  "grid-width-sm-4": "IgfSgW_grid-width-sm-4",
  "grid-width-sm-5": "IgfSgW_grid-width-sm-5",
  "grid-width-sm-6": "IgfSgW_grid-width-sm-6",
  "grid-width-sm-7": "IgfSgW_grid-width-sm-7",
  "grid-width-sm-8": "IgfSgW_grid-width-sm-8",
  "grid-width-sm-9": "IgfSgW_grid-width-sm-9",
  "grid-width-xl-1": "IgfSgW_grid-width-xl-1",
  "grid-width-xl-10": "IgfSgW_grid-width-xl-10",
  "grid-width-xl-11": "IgfSgW_grid-width-xl-11",
  "grid-width-xl-12": "IgfSgW_grid-width-xl-12",
  "grid-width-xl-13": "IgfSgW_grid-width-xl-13",
  "grid-width-xl-14": "IgfSgW_grid-width-xl-14",
  "grid-width-xl-2": "IgfSgW_grid-width-xl-2",
  "grid-width-xl-3": "IgfSgW_grid-width-xl-3",
  "grid-width-xl-4": "IgfSgW_grid-width-xl-4",
  "grid-width-xl-5": "IgfSgW_grid-width-xl-5",
  "grid-width-xl-6": "IgfSgW_grid-width-xl-6",
  "grid-width-xl-7": "IgfSgW_grid-width-xl-7",
  "grid-width-xl-8": "IgfSgW_grid-width-xl-8",
  "grid-width-xl-9": "IgfSgW_grid-width-xl-9",
  "jc-lg-center": "IgfSgW_jc-lg-center",
  "jc-lg-end": "IgfSgW_jc-lg-end",
  "jc-lg-flex-end": "IgfSgW_jc-lg-flex-end",
  "jc-lg-flex-start": "IgfSgW_jc-lg-flex-start",
  "jc-lg-left": "IgfSgW_jc-lg-left",
  "jc-lg-normal": "IgfSgW_jc-lg-normal",
  "jc-lg-right": "IgfSgW_jc-lg-right",
  "jc-lg-space-around": "IgfSgW_jc-lg-space-around",
  "jc-lg-space-between": "IgfSgW_jc-lg-space-between",
  "jc-lg-space-evenly": "IgfSgW_jc-lg-space-evenly",
  "jc-lg-start": "IgfSgW_jc-lg-start",
  "jc-lg-stretch": "IgfSgW_jc-lg-stretch",
  "jc-md-center": "IgfSgW_jc-md-center",
  "jc-md-end": "IgfSgW_jc-md-end",
  "jc-md-flex-end": "IgfSgW_jc-md-flex-end",
  "jc-md-flex-start": "IgfSgW_jc-md-flex-start",
  "jc-md-left": "IgfSgW_jc-md-left",
  "jc-md-normal": "IgfSgW_jc-md-normal",
  "jc-md-right": "IgfSgW_jc-md-right",
  "jc-md-space-around": "IgfSgW_jc-md-space-around",
  "jc-md-space-between": "IgfSgW_jc-md-space-between",
  "jc-md-space-evenly": "IgfSgW_jc-md-space-evenly",
  "jc-md-start": "IgfSgW_jc-md-start",
  "jc-md-stretch": "IgfSgW_jc-md-stretch",
  "jc-sm-center": "IgfSgW_jc-sm-center",
  "jc-sm-end": "IgfSgW_jc-sm-end",
  "jc-sm-flex-end": "IgfSgW_jc-sm-flex-end",
  "jc-sm-flex-start": "IgfSgW_jc-sm-flex-start",
  "jc-sm-left": "IgfSgW_jc-sm-left",
  "jc-sm-normal": "IgfSgW_jc-sm-normal",
  "jc-sm-right": "IgfSgW_jc-sm-right",
  "jc-sm-space-around": "IgfSgW_jc-sm-space-around",
  "jc-sm-space-between": "IgfSgW_jc-sm-space-between",
  "jc-sm-space-evenly": "IgfSgW_jc-sm-space-evenly",
  "jc-sm-start": "IgfSgW_jc-sm-start",
  "jc-sm-stretch": "IgfSgW_jc-sm-stretch",
  "jc-xl-center": "IgfSgW_jc-xl-center",
  "jc-xl-end": "IgfSgW_jc-xl-end",
  "jc-xl-flex-end": "IgfSgW_jc-xl-flex-end",
  "jc-xl-flex-start": "IgfSgW_jc-xl-flex-start",
  "jc-xl-left": "IgfSgW_jc-xl-left",
  "jc-xl-normal": "IgfSgW_jc-xl-normal",
  "jc-xl-right": "IgfSgW_jc-xl-right",
  "jc-xl-space-around": "IgfSgW_jc-xl-space-around",
  "jc-xl-space-between": "IgfSgW_jc-xl-space-between",
  "jc-xl-space-evenly": "IgfSgW_jc-xl-space-evenly",
  "jc-xl-start": "IgfSgW_jc-xl-start",
  "jc-xl-stretch": "IgfSgW_jc-xl-stretch",
  "ji-lg-baseline": "IgfSgW_ji-lg-baseline",
  "ji-lg-center": "IgfSgW_ji-lg-center",
  "ji-lg-end": "IgfSgW_ji-lg-end",
  "ji-lg-flex-end": "IgfSgW_ji-lg-flex-end",
  "ji-lg-flex-start": "IgfSgW_ji-lg-flex-start",
  "ji-lg-left": "IgfSgW_ji-lg-left",
  "ji-lg-normal": "IgfSgW_ji-lg-normal",
  "ji-lg-right": "IgfSgW_ji-lg-right",
  "ji-lg-self-end": "IgfSgW_ji-lg-self-end",
  "ji-lg-self-start": "IgfSgW_ji-lg-self-start",
  "ji-lg-start": "IgfSgW_ji-lg-start",
  "ji-lg-stretch": "IgfSgW_ji-lg-stretch",
  "ji-md-baseline": "IgfSgW_ji-md-baseline",
  "ji-md-center": "IgfSgW_ji-md-center",
  "ji-md-end": "IgfSgW_ji-md-end",
  "ji-md-flex-end": "IgfSgW_ji-md-flex-end",
  "ji-md-flex-start": "IgfSgW_ji-md-flex-start",
  "ji-md-left": "IgfSgW_ji-md-left",
  "ji-md-normal": "IgfSgW_ji-md-normal",
  "ji-md-right": "IgfSgW_ji-md-right",
  "ji-md-self-end": "IgfSgW_ji-md-self-end",
  "ji-md-self-start": "IgfSgW_ji-md-self-start",
  "ji-md-start": "IgfSgW_ji-md-start",
  "ji-md-stretch": "IgfSgW_ji-md-stretch",
  "ji-sm-baseline": "IgfSgW_ji-sm-baseline",
  "ji-sm-center": "IgfSgW_ji-sm-center",
  "ji-sm-end": "IgfSgW_ji-sm-end",
  "ji-sm-flex-end": "IgfSgW_ji-sm-flex-end",
  "ji-sm-flex-start": "IgfSgW_ji-sm-flex-start",
  "ji-sm-left": "IgfSgW_ji-sm-left",
  "ji-sm-normal": "IgfSgW_ji-sm-normal",
  "ji-sm-right": "IgfSgW_ji-sm-right",
  "ji-sm-self-end": "IgfSgW_ji-sm-self-end",
  "ji-sm-self-start": "IgfSgW_ji-sm-self-start",
  "ji-sm-start": "IgfSgW_ji-sm-start",
  "ji-sm-stretch": "IgfSgW_ji-sm-stretch",
  "ji-xl-baseline": "IgfSgW_ji-xl-baseline",
  "ji-xl-center": "IgfSgW_ji-xl-center",
  "ji-xl-end": "IgfSgW_ji-xl-end",
  "ji-xl-flex-end": "IgfSgW_ji-xl-flex-end",
  "ji-xl-flex-start": "IgfSgW_ji-xl-flex-start",
  "ji-xl-left": "IgfSgW_ji-xl-left",
  "ji-xl-normal": "IgfSgW_ji-xl-normal",
  "ji-xl-right": "IgfSgW_ji-xl-right",
  "ji-xl-self-end": "IgfSgW_ji-xl-self-end",
  "ji-xl-self-start": "IgfSgW_ji-xl-self-start",
  "ji-xl-start": "IgfSgW_ji-xl-start",
  "ji-xl-stretch": "IgfSgW_ji-xl-stretch",
  "m-lg-0": "IgfSgW_m-lg-0",
  "m-lg-1": "IgfSgW_m-lg-1",
  "m-lg-10": "IgfSgW_m-lg-10",
  "m-lg-11": "IgfSgW_m-lg-11",
  "m-lg-12": "IgfSgW_m-lg-12",
  "m-lg-13": "IgfSgW_m-lg-13",
  "m-lg-14": "IgfSgW_m-lg-14",
  "m-lg-2": "IgfSgW_m-lg-2",
  "m-lg-3": "IgfSgW_m-lg-3",
  "m-lg-4": "IgfSgW_m-lg-4",
  "m-lg-5": "IgfSgW_m-lg-5",
  "m-lg-6": "IgfSgW_m-lg-6",
  "m-lg-7": "IgfSgW_m-lg-7",
  "m-lg-8": "IgfSgW_m-lg-8",
  "m-lg-9": "IgfSgW_m-lg-9",
  "m-lg-auto": "IgfSgW_m-lg-auto",
  "m-md-0": "IgfSgW_m-md-0",
  "m-md-1": "IgfSgW_m-md-1",
  "m-md-10": "IgfSgW_m-md-10",
  "m-md-11": "IgfSgW_m-md-11",
  "m-md-12": "IgfSgW_m-md-12",
  "m-md-13": "IgfSgW_m-md-13",
  "m-md-14": "IgfSgW_m-md-14",
  "m-md-2": "IgfSgW_m-md-2",
  "m-md-3": "IgfSgW_m-md-3",
  "m-md-4": "IgfSgW_m-md-4",
  "m-md-5": "IgfSgW_m-md-5",
  "m-md-6": "IgfSgW_m-md-6",
  "m-md-7": "IgfSgW_m-md-7",
  "m-md-8": "IgfSgW_m-md-8",
  "m-md-9": "IgfSgW_m-md-9",
  "m-md-auto": "IgfSgW_m-md-auto",
  "m-sm-0": "IgfSgW_m-sm-0",
  "m-sm-1": "IgfSgW_m-sm-1",
  "m-sm-10": "IgfSgW_m-sm-10",
  "m-sm-11": "IgfSgW_m-sm-11",
  "m-sm-12": "IgfSgW_m-sm-12",
  "m-sm-13": "IgfSgW_m-sm-13",
  "m-sm-14": "IgfSgW_m-sm-14",
  "m-sm-2": "IgfSgW_m-sm-2",
  "m-sm-3": "IgfSgW_m-sm-3",
  "m-sm-4": "IgfSgW_m-sm-4",
  "m-sm-5": "IgfSgW_m-sm-5",
  "m-sm-6": "IgfSgW_m-sm-6",
  "m-sm-7": "IgfSgW_m-sm-7",
  "m-sm-8": "IgfSgW_m-sm-8",
  "m-sm-9": "IgfSgW_m-sm-9",
  "m-sm-auto": "IgfSgW_m-sm-auto",
  "m-xl-0": "IgfSgW_m-xl-0",
  "m-xl-1": "IgfSgW_m-xl-1",
  "m-xl-10": "IgfSgW_m-xl-10",
  "m-xl-11": "IgfSgW_m-xl-11",
  "m-xl-12": "IgfSgW_m-xl-12",
  "m-xl-13": "IgfSgW_m-xl-13",
  "m-xl-14": "IgfSgW_m-xl-14",
  "m-xl-2": "IgfSgW_m-xl-2",
  "m-xl-3": "IgfSgW_m-xl-3",
  "m-xl-4": "IgfSgW_m-xl-4",
  "m-xl-5": "IgfSgW_m-xl-5",
  "m-xl-6": "IgfSgW_m-xl-6",
  "m-xl-7": "IgfSgW_m-xl-7",
  "m-xl-8": "IgfSgW_m-xl-8",
  "m-xl-9": "IgfSgW_m-xl-9",
  "m-xl-auto": "IgfSgW_m-xl-auto",
  "mb-lg-0": "IgfSgW_mb-lg-0",
  "mb-lg-1": "IgfSgW_mb-lg-1",
  "mb-lg-10": "IgfSgW_mb-lg-10",
  "mb-lg-11": "IgfSgW_mb-lg-11",
  "mb-lg-12": "IgfSgW_mb-lg-12",
  "mb-lg-13": "IgfSgW_mb-lg-13",
  "mb-lg-14": "IgfSgW_mb-lg-14",
  "mb-lg-2": "IgfSgW_mb-lg-2",
  "mb-lg-3": "IgfSgW_mb-lg-3",
  "mb-lg-4": "IgfSgW_mb-lg-4",
  "mb-lg-5": "IgfSgW_mb-lg-5",
  "mb-lg-6": "IgfSgW_mb-lg-6",
  "mb-lg-7": "IgfSgW_mb-lg-7",
  "mb-lg-8": "IgfSgW_mb-lg-8",
  "mb-lg-9": "IgfSgW_mb-lg-9",
  "mb-lg-auto": "IgfSgW_mb-lg-auto",
  "mb-md-0": "IgfSgW_mb-md-0",
  "mb-md-1": "IgfSgW_mb-md-1",
  "mb-md-10": "IgfSgW_mb-md-10",
  "mb-md-11": "IgfSgW_mb-md-11",
  "mb-md-12": "IgfSgW_mb-md-12",
  "mb-md-13": "IgfSgW_mb-md-13",
  "mb-md-14": "IgfSgW_mb-md-14",
  "mb-md-2": "IgfSgW_mb-md-2",
  "mb-md-3": "IgfSgW_mb-md-3",
  "mb-md-4": "IgfSgW_mb-md-4",
  "mb-md-5": "IgfSgW_mb-md-5",
  "mb-md-6": "IgfSgW_mb-md-6",
  "mb-md-7": "IgfSgW_mb-md-7",
  "mb-md-8": "IgfSgW_mb-md-8",
  "mb-md-9": "IgfSgW_mb-md-9",
  "mb-md-auto": "IgfSgW_mb-md-auto",
  "mb-sm-0": "IgfSgW_mb-sm-0",
  "mb-sm-1": "IgfSgW_mb-sm-1",
  "mb-sm-10": "IgfSgW_mb-sm-10",
  "mb-sm-11": "IgfSgW_mb-sm-11",
  "mb-sm-12": "IgfSgW_mb-sm-12",
  "mb-sm-13": "IgfSgW_mb-sm-13",
  "mb-sm-14": "IgfSgW_mb-sm-14",
  "mb-sm-2": "IgfSgW_mb-sm-2",
  "mb-sm-3": "IgfSgW_mb-sm-3",
  "mb-sm-4": "IgfSgW_mb-sm-4",
  "mb-sm-5": "IgfSgW_mb-sm-5",
  "mb-sm-6": "IgfSgW_mb-sm-6",
  "mb-sm-7": "IgfSgW_mb-sm-7",
  "mb-sm-8": "IgfSgW_mb-sm-8",
  "mb-sm-9": "IgfSgW_mb-sm-9",
  "mb-sm-auto": "IgfSgW_mb-sm-auto",
  "mb-xl-0": "IgfSgW_mb-xl-0",
  "mb-xl-1": "IgfSgW_mb-xl-1",
  "mb-xl-10": "IgfSgW_mb-xl-10",
  "mb-xl-11": "IgfSgW_mb-xl-11",
  "mb-xl-12": "IgfSgW_mb-xl-12",
  "mb-xl-13": "IgfSgW_mb-xl-13",
  "mb-xl-14": "IgfSgW_mb-xl-14",
  "mb-xl-2": "IgfSgW_mb-xl-2",
  "mb-xl-3": "IgfSgW_mb-xl-3",
  "mb-xl-4": "IgfSgW_mb-xl-4",
  "mb-xl-5": "IgfSgW_mb-xl-5",
  "mb-xl-6": "IgfSgW_mb-xl-6",
  "mb-xl-7": "IgfSgW_mb-xl-7",
  "mb-xl-8": "IgfSgW_mb-xl-8",
  "mb-xl-9": "IgfSgW_mb-xl-9",
  "mb-xl-auto": "IgfSgW_mb-xl-auto",
  "ml-lg-0": "IgfSgW_ml-lg-0",
  "ml-lg-1": "IgfSgW_ml-lg-1",
  "ml-lg-10": "IgfSgW_ml-lg-10",
  "ml-lg-11": "IgfSgW_ml-lg-11",
  "ml-lg-12": "IgfSgW_ml-lg-12",
  "ml-lg-13": "IgfSgW_ml-lg-13",
  "ml-lg-14": "IgfSgW_ml-lg-14",
  "ml-lg-2": "IgfSgW_ml-lg-2",
  "ml-lg-3": "IgfSgW_ml-lg-3",
  "ml-lg-4": "IgfSgW_ml-lg-4",
  "ml-lg-5": "IgfSgW_ml-lg-5",
  "ml-lg-6": "IgfSgW_ml-lg-6",
  "ml-lg-7": "IgfSgW_ml-lg-7",
  "ml-lg-8": "IgfSgW_ml-lg-8",
  "ml-lg-9": "IgfSgW_ml-lg-9",
  "ml-lg-auto": "IgfSgW_ml-lg-auto",
  "ml-md-0": "IgfSgW_ml-md-0",
  "ml-md-1": "IgfSgW_ml-md-1",
  "ml-md-10": "IgfSgW_ml-md-10",
  "ml-md-11": "IgfSgW_ml-md-11",
  "ml-md-12": "IgfSgW_ml-md-12",
  "ml-md-13": "IgfSgW_ml-md-13",
  "ml-md-14": "IgfSgW_ml-md-14",
  "ml-md-2": "IgfSgW_ml-md-2",
  "ml-md-3": "IgfSgW_ml-md-3",
  "ml-md-4": "IgfSgW_ml-md-4",
  "ml-md-5": "IgfSgW_ml-md-5",
  "ml-md-6": "IgfSgW_ml-md-6",
  "ml-md-7": "IgfSgW_ml-md-7",
  "ml-md-8": "IgfSgW_ml-md-8",
  "ml-md-9": "IgfSgW_ml-md-9",
  "ml-md-auto": "IgfSgW_ml-md-auto",
  "ml-sm-0": "IgfSgW_ml-sm-0",
  "ml-sm-1": "IgfSgW_ml-sm-1",
  "ml-sm-10": "IgfSgW_ml-sm-10",
  "ml-sm-11": "IgfSgW_ml-sm-11",
  "ml-sm-12": "IgfSgW_ml-sm-12",
  "ml-sm-13": "IgfSgW_ml-sm-13",
  "ml-sm-14": "IgfSgW_ml-sm-14",
  "ml-sm-2": "IgfSgW_ml-sm-2",
  "ml-sm-3": "IgfSgW_ml-sm-3",
  "ml-sm-4": "IgfSgW_ml-sm-4",
  "ml-sm-5": "IgfSgW_ml-sm-5",
  "ml-sm-6": "IgfSgW_ml-sm-6",
  "ml-sm-7": "IgfSgW_ml-sm-7",
  "ml-sm-8": "IgfSgW_ml-sm-8",
  "ml-sm-9": "IgfSgW_ml-sm-9",
  "ml-sm-auto": "IgfSgW_ml-sm-auto",
  "ml-xl-0": "IgfSgW_ml-xl-0",
  "ml-xl-1": "IgfSgW_ml-xl-1",
  "ml-xl-10": "IgfSgW_ml-xl-10",
  "ml-xl-11": "IgfSgW_ml-xl-11",
  "ml-xl-12": "IgfSgW_ml-xl-12",
  "ml-xl-13": "IgfSgW_ml-xl-13",
  "ml-xl-14": "IgfSgW_ml-xl-14",
  "ml-xl-2": "IgfSgW_ml-xl-2",
  "ml-xl-3": "IgfSgW_ml-xl-3",
  "ml-xl-4": "IgfSgW_ml-xl-4",
  "ml-xl-5": "IgfSgW_ml-xl-5",
  "ml-xl-6": "IgfSgW_ml-xl-6",
  "ml-xl-7": "IgfSgW_ml-xl-7",
  "ml-xl-8": "IgfSgW_ml-xl-8",
  "ml-xl-9": "IgfSgW_ml-xl-9",
  "ml-xl-auto": "IgfSgW_ml-xl-auto",
  "mr-lg-0": "IgfSgW_mr-lg-0",
  "mr-lg-1": "IgfSgW_mr-lg-1",
  "mr-lg-10": "IgfSgW_mr-lg-10",
  "mr-lg-11": "IgfSgW_mr-lg-11",
  "mr-lg-12": "IgfSgW_mr-lg-12",
  "mr-lg-13": "IgfSgW_mr-lg-13",
  "mr-lg-14": "IgfSgW_mr-lg-14",
  "mr-lg-2": "IgfSgW_mr-lg-2",
  "mr-lg-3": "IgfSgW_mr-lg-3",
  "mr-lg-4": "IgfSgW_mr-lg-4",
  "mr-lg-5": "IgfSgW_mr-lg-5",
  "mr-lg-6": "IgfSgW_mr-lg-6",
  "mr-lg-7": "IgfSgW_mr-lg-7",
  "mr-lg-8": "IgfSgW_mr-lg-8",
  "mr-lg-9": "IgfSgW_mr-lg-9",
  "mr-lg-auto": "IgfSgW_mr-lg-auto",
  "mr-md-0": "IgfSgW_mr-md-0",
  "mr-md-1": "IgfSgW_mr-md-1",
  "mr-md-10": "IgfSgW_mr-md-10",
  "mr-md-11": "IgfSgW_mr-md-11",
  "mr-md-12": "IgfSgW_mr-md-12",
  "mr-md-13": "IgfSgW_mr-md-13",
  "mr-md-14": "IgfSgW_mr-md-14",
  "mr-md-2": "IgfSgW_mr-md-2",
  "mr-md-3": "IgfSgW_mr-md-3",
  "mr-md-4": "IgfSgW_mr-md-4",
  "mr-md-5": "IgfSgW_mr-md-5",
  "mr-md-6": "IgfSgW_mr-md-6",
  "mr-md-7": "IgfSgW_mr-md-7",
  "mr-md-8": "IgfSgW_mr-md-8",
  "mr-md-9": "IgfSgW_mr-md-9",
  "mr-md-auto": "IgfSgW_mr-md-auto",
  "mr-sm-0": "IgfSgW_mr-sm-0",
  "mr-sm-1": "IgfSgW_mr-sm-1",
  "mr-sm-10": "IgfSgW_mr-sm-10",
  "mr-sm-11": "IgfSgW_mr-sm-11",
  "mr-sm-12": "IgfSgW_mr-sm-12",
  "mr-sm-13": "IgfSgW_mr-sm-13",
  "mr-sm-14": "IgfSgW_mr-sm-14",
  "mr-sm-2": "IgfSgW_mr-sm-2",
  "mr-sm-3": "IgfSgW_mr-sm-3",
  "mr-sm-4": "IgfSgW_mr-sm-4",
  "mr-sm-5": "IgfSgW_mr-sm-5",
  "mr-sm-6": "IgfSgW_mr-sm-6",
  "mr-sm-7": "IgfSgW_mr-sm-7",
  "mr-sm-8": "IgfSgW_mr-sm-8",
  "mr-sm-9": "IgfSgW_mr-sm-9",
  "mr-sm-auto": "IgfSgW_mr-sm-auto",
  "mr-xl-0": "IgfSgW_mr-xl-0",
  "mr-xl-1": "IgfSgW_mr-xl-1",
  "mr-xl-10": "IgfSgW_mr-xl-10",
  "mr-xl-11": "IgfSgW_mr-xl-11",
  "mr-xl-12": "IgfSgW_mr-xl-12",
  "mr-xl-13": "IgfSgW_mr-xl-13",
  "mr-xl-14": "IgfSgW_mr-xl-14",
  "mr-xl-2": "IgfSgW_mr-xl-2",
  "mr-xl-3": "IgfSgW_mr-xl-3",
  "mr-xl-4": "IgfSgW_mr-xl-4",
  "mr-xl-5": "IgfSgW_mr-xl-5",
  "mr-xl-6": "IgfSgW_mr-xl-6",
  "mr-xl-7": "IgfSgW_mr-xl-7",
  "mr-xl-8": "IgfSgW_mr-xl-8",
  "mr-xl-9": "IgfSgW_mr-xl-9",
  "mr-xl-auto": "IgfSgW_mr-xl-auto",
  "mt-lg-0": "IgfSgW_mt-lg-0",
  "mt-lg-1": "IgfSgW_mt-lg-1",
  "mt-lg-10": "IgfSgW_mt-lg-10",
  "mt-lg-11": "IgfSgW_mt-lg-11",
  "mt-lg-12": "IgfSgW_mt-lg-12",
  "mt-lg-13": "IgfSgW_mt-lg-13",
  "mt-lg-14": "IgfSgW_mt-lg-14",
  "mt-lg-2": "IgfSgW_mt-lg-2",
  "mt-lg-3": "IgfSgW_mt-lg-3",
  "mt-lg-4": "IgfSgW_mt-lg-4",
  "mt-lg-5": "IgfSgW_mt-lg-5",
  "mt-lg-6": "IgfSgW_mt-lg-6",
  "mt-lg-7": "IgfSgW_mt-lg-7",
  "mt-lg-8": "IgfSgW_mt-lg-8",
  "mt-lg-9": "IgfSgW_mt-lg-9",
  "mt-lg-auto": "IgfSgW_mt-lg-auto",
  "mt-md-0": "IgfSgW_mt-md-0",
  "mt-md-1": "IgfSgW_mt-md-1",
  "mt-md-10": "IgfSgW_mt-md-10",
  "mt-md-11": "IgfSgW_mt-md-11",
  "mt-md-12": "IgfSgW_mt-md-12",
  "mt-md-13": "IgfSgW_mt-md-13",
  "mt-md-14": "IgfSgW_mt-md-14",
  "mt-md-2": "IgfSgW_mt-md-2",
  "mt-md-3": "IgfSgW_mt-md-3",
  "mt-md-4": "IgfSgW_mt-md-4",
  "mt-md-5": "IgfSgW_mt-md-5",
  "mt-md-6": "IgfSgW_mt-md-6",
  "mt-md-7": "IgfSgW_mt-md-7",
  "mt-md-8": "IgfSgW_mt-md-8",
  "mt-md-9": "IgfSgW_mt-md-9",
  "mt-md-auto": "IgfSgW_mt-md-auto",
  "mt-sm-0": "IgfSgW_mt-sm-0",
  "mt-sm-1": "IgfSgW_mt-sm-1",
  "mt-sm-10": "IgfSgW_mt-sm-10",
  "mt-sm-11": "IgfSgW_mt-sm-11",
  "mt-sm-12": "IgfSgW_mt-sm-12",
  "mt-sm-13": "IgfSgW_mt-sm-13",
  "mt-sm-14": "IgfSgW_mt-sm-14",
  "mt-sm-2": "IgfSgW_mt-sm-2",
  "mt-sm-3": "IgfSgW_mt-sm-3",
  "mt-sm-4": "IgfSgW_mt-sm-4",
  "mt-sm-5": "IgfSgW_mt-sm-5",
  "mt-sm-6": "IgfSgW_mt-sm-6",
  "mt-sm-7": "IgfSgW_mt-sm-7",
  "mt-sm-8": "IgfSgW_mt-sm-8",
  "mt-sm-9": "IgfSgW_mt-sm-9",
  "mt-sm-auto": "IgfSgW_mt-sm-auto",
  "mt-xl-0": "IgfSgW_mt-xl-0",
  "mt-xl-1": "IgfSgW_mt-xl-1",
  "mt-xl-10": "IgfSgW_mt-xl-10",
  "mt-xl-11": "IgfSgW_mt-xl-11",
  "mt-xl-12": "IgfSgW_mt-xl-12",
  "mt-xl-13": "IgfSgW_mt-xl-13",
  "mt-xl-14": "IgfSgW_mt-xl-14",
  "mt-xl-2": "IgfSgW_mt-xl-2",
  "mt-xl-3": "IgfSgW_mt-xl-3",
  "mt-xl-4": "IgfSgW_mt-xl-4",
  "mt-xl-5": "IgfSgW_mt-xl-5",
  "mt-xl-6": "IgfSgW_mt-xl-6",
  "mt-xl-7": "IgfSgW_mt-xl-7",
  "mt-xl-8": "IgfSgW_mt-xl-8",
  "mt-xl-9": "IgfSgW_mt-xl-9",
  "mt-xl-auto": "IgfSgW_mt-xl-auto",
  "p-lg-0": "IgfSgW_p-lg-0",
  "p-lg-1": "IgfSgW_p-lg-1",
  "p-lg-10": "IgfSgW_p-lg-10",
  "p-lg-11": "IgfSgW_p-lg-11",
  "p-lg-12": "IgfSgW_p-lg-12",
  "p-lg-13": "IgfSgW_p-lg-13",
  "p-lg-14": "IgfSgW_p-lg-14",
  "p-lg-2": "IgfSgW_p-lg-2",
  "p-lg-3": "IgfSgW_p-lg-3",
  "p-lg-4": "IgfSgW_p-lg-4",
  "p-lg-5": "IgfSgW_p-lg-5",
  "p-lg-6": "IgfSgW_p-lg-6",
  "p-lg-7": "IgfSgW_p-lg-7",
  "p-lg-8": "IgfSgW_p-lg-8",
  "p-lg-9": "IgfSgW_p-lg-9",
  "p-lg-auto": "IgfSgW_p-lg-auto",
  "p-md-0": "IgfSgW_p-md-0",
  "p-md-1": "IgfSgW_p-md-1",
  "p-md-10": "IgfSgW_p-md-10",
  "p-md-11": "IgfSgW_p-md-11",
  "p-md-12": "IgfSgW_p-md-12",
  "p-md-13": "IgfSgW_p-md-13",
  "p-md-14": "IgfSgW_p-md-14",
  "p-md-2": "IgfSgW_p-md-2",
  "p-md-3": "IgfSgW_p-md-3",
  "p-md-4": "IgfSgW_p-md-4",
  "p-md-5": "IgfSgW_p-md-5",
  "p-md-6": "IgfSgW_p-md-6",
  "p-md-7": "IgfSgW_p-md-7",
  "p-md-8": "IgfSgW_p-md-8",
  "p-md-9": "IgfSgW_p-md-9",
  "p-md-auto": "IgfSgW_p-md-auto",
  "p-sm-0": "IgfSgW_p-sm-0",
  "p-sm-1": "IgfSgW_p-sm-1",
  "p-sm-10": "IgfSgW_p-sm-10",
  "p-sm-11": "IgfSgW_p-sm-11",
  "p-sm-12": "IgfSgW_p-sm-12",
  "p-sm-13": "IgfSgW_p-sm-13",
  "p-sm-14": "IgfSgW_p-sm-14",
  "p-sm-2": "IgfSgW_p-sm-2",
  "p-sm-3": "IgfSgW_p-sm-3",
  "p-sm-4": "IgfSgW_p-sm-4",
  "p-sm-5": "IgfSgW_p-sm-5",
  "p-sm-6": "IgfSgW_p-sm-6",
  "p-sm-7": "IgfSgW_p-sm-7",
  "p-sm-8": "IgfSgW_p-sm-8",
  "p-sm-9": "IgfSgW_p-sm-9",
  "p-sm-auto": "IgfSgW_p-sm-auto",
  "p-xl-0": "IgfSgW_p-xl-0",
  "p-xl-1": "IgfSgW_p-xl-1",
  "p-xl-10": "IgfSgW_p-xl-10",
  "p-xl-11": "IgfSgW_p-xl-11",
  "p-xl-12": "IgfSgW_p-xl-12",
  "p-xl-13": "IgfSgW_p-xl-13",
  "p-xl-14": "IgfSgW_p-xl-14",
  "p-xl-2": "IgfSgW_p-xl-2",
  "p-xl-3": "IgfSgW_p-xl-3",
  "p-xl-4": "IgfSgW_p-xl-4",
  "p-xl-5": "IgfSgW_p-xl-5",
  "p-xl-6": "IgfSgW_p-xl-6",
  "p-xl-7": "IgfSgW_p-xl-7",
  "p-xl-8": "IgfSgW_p-xl-8",
  "p-xl-9": "IgfSgW_p-xl-9",
  "p-xl-auto": "IgfSgW_p-xl-auto",
  "pb-lg-0": "IgfSgW_pb-lg-0",
  "pb-lg-1": "IgfSgW_pb-lg-1",
  "pb-lg-10": "IgfSgW_pb-lg-10",
  "pb-lg-11": "IgfSgW_pb-lg-11",
  "pb-lg-12": "IgfSgW_pb-lg-12",
  "pb-lg-13": "IgfSgW_pb-lg-13",
  "pb-lg-14": "IgfSgW_pb-lg-14",
  "pb-lg-2": "IgfSgW_pb-lg-2",
  "pb-lg-3": "IgfSgW_pb-lg-3",
  "pb-lg-4": "IgfSgW_pb-lg-4",
  "pb-lg-5": "IgfSgW_pb-lg-5",
  "pb-lg-6": "IgfSgW_pb-lg-6",
  "pb-lg-7": "IgfSgW_pb-lg-7",
  "pb-lg-8": "IgfSgW_pb-lg-8",
  "pb-lg-9": "IgfSgW_pb-lg-9",
  "pb-lg-auto": "IgfSgW_pb-lg-auto",
  "pb-md-0": "IgfSgW_pb-md-0",
  "pb-md-1": "IgfSgW_pb-md-1",
  "pb-md-10": "IgfSgW_pb-md-10",
  "pb-md-11": "IgfSgW_pb-md-11",
  "pb-md-12": "IgfSgW_pb-md-12",
  "pb-md-13": "IgfSgW_pb-md-13",
  "pb-md-14": "IgfSgW_pb-md-14",
  "pb-md-2": "IgfSgW_pb-md-2",
  "pb-md-3": "IgfSgW_pb-md-3",
  "pb-md-4": "IgfSgW_pb-md-4",
  "pb-md-5": "IgfSgW_pb-md-5",
  "pb-md-6": "IgfSgW_pb-md-6",
  "pb-md-7": "IgfSgW_pb-md-7",
  "pb-md-8": "IgfSgW_pb-md-8",
  "pb-md-9": "IgfSgW_pb-md-9",
  "pb-md-auto": "IgfSgW_pb-md-auto",
  "pb-sm-0": "IgfSgW_pb-sm-0",
  "pb-sm-1": "IgfSgW_pb-sm-1",
  "pb-sm-10": "IgfSgW_pb-sm-10",
  "pb-sm-11": "IgfSgW_pb-sm-11",
  "pb-sm-12": "IgfSgW_pb-sm-12",
  "pb-sm-13": "IgfSgW_pb-sm-13",
  "pb-sm-14": "IgfSgW_pb-sm-14",
  "pb-sm-2": "IgfSgW_pb-sm-2",
  "pb-sm-3": "IgfSgW_pb-sm-3",
  "pb-sm-4": "IgfSgW_pb-sm-4",
  "pb-sm-5": "IgfSgW_pb-sm-5",
  "pb-sm-6": "IgfSgW_pb-sm-6",
  "pb-sm-7": "IgfSgW_pb-sm-7",
  "pb-sm-8": "IgfSgW_pb-sm-8",
  "pb-sm-9": "IgfSgW_pb-sm-9",
  "pb-sm-auto": "IgfSgW_pb-sm-auto",
  "pb-xl-0": "IgfSgW_pb-xl-0",
  "pb-xl-1": "IgfSgW_pb-xl-1",
  "pb-xl-10": "IgfSgW_pb-xl-10",
  "pb-xl-11": "IgfSgW_pb-xl-11",
  "pb-xl-12": "IgfSgW_pb-xl-12",
  "pb-xl-13": "IgfSgW_pb-xl-13",
  "pb-xl-14": "IgfSgW_pb-xl-14",
  "pb-xl-2": "IgfSgW_pb-xl-2",
  "pb-xl-3": "IgfSgW_pb-xl-3",
  "pb-xl-4": "IgfSgW_pb-xl-4",
  "pb-xl-5": "IgfSgW_pb-xl-5",
  "pb-xl-6": "IgfSgW_pb-xl-6",
  "pb-xl-7": "IgfSgW_pb-xl-7",
  "pb-xl-8": "IgfSgW_pb-xl-8",
  "pb-xl-9": "IgfSgW_pb-xl-9",
  "pb-xl-auto": "IgfSgW_pb-xl-auto",
  "pl-lg-0": "IgfSgW_pl-lg-0",
  "pl-lg-1": "IgfSgW_pl-lg-1",
  "pl-lg-10": "IgfSgW_pl-lg-10",
  "pl-lg-11": "IgfSgW_pl-lg-11",
  "pl-lg-12": "IgfSgW_pl-lg-12",
  "pl-lg-13": "IgfSgW_pl-lg-13",
  "pl-lg-14": "IgfSgW_pl-lg-14",
  "pl-lg-2": "IgfSgW_pl-lg-2",
  "pl-lg-3": "IgfSgW_pl-lg-3",
  "pl-lg-4": "IgfSgW_pl-lg-4",
  "pl-lg-5": "IgfSgW_pl-lg-5",
  "pl-lg-6": "IgfSgW_pl-lg-6",
  "pl-lg-7": "IgfSgW_pl-lg-7",
  "pl-lg-8": "IgfSgW_pl-lg-8",
  "pl-lg-9": "IgfSgW_pl-lg-9",
  "pl-lg-auto": "IgfSgW_pl-lg-auto",
  "pl-md-0": "IgfSgW_pl-md-0",
  "pl-md-1": "IgfSgW_pl-md-1",
  "pl-md-10": "IgfSgW_pl-md-10",
  "pl-md-11": "IgfSgW_pl-md-11",
  "pl-md-12": "IgfSgW_pl-md-12",
  "pl-md-13": "IgfSgW_pl-md-13",
  "pl-md-14": "IgfSgW_pl-md-14",
  "pl-md-2": "IgfSgW_pl-md-2",
  "pl-md-3": "IgfSgW_pl-md-3",
  "pl-md-4": "IgfSgW_pl-md-4",
  "pl-md-5": "IgfSgW_pl-md-5",
  "pl-md-6": "IgfSgW_pl-md-6",
  "pl-md-7": "IgfSgW_pl-md-7",
  "pl-md-8": "IgfSgW_pl-md-8",
  "pl-md-9": "IgfSgW_pl-md-9",
  "pl-md-auto": "IgfSgW_pl-md-auto",
  "pl-sm-0": "IgfSgW_pl-sm-0",
  "pl-sm-1": "IgfSgW_pl-sm-1",
  "pl-sm-10": "IgfSgW_pl-sm-10",
  "pl-sm-11": "IgfSgW_pl-sm-11",
  "pl-sm-12": "IgfSgW_pl-sm-12",
  "pl-sm-13": "IgfSgW_pl-sm-13",
  "pl-sm-14": "IgfSgW_pl-sm-14",
  "pl-sm-2": "IgfSgW_pl-sm-2",
  "pl-sm-3": "IgfSgW_pl-sm-3",
  "pl-sm-4": "IgfSgW_pl-sm-4",
  "pl-sm-5": "IgfSgW_pl-sm-5",
  "pl-sm-6": "IgfSgW_pl-sm-6",
  "pl-sm-7": "IgfSgW_pl-sm-7",
  "pl-sm-8": "IgfSgW_pl-sm-8",
  "pl-sm-9": "IgfSgW_pl-sm-9",
  "pl-sm-auto": "IgfSgW_pl-sm-auto",
  "pl-xl-0": "IgfSgW_pl-xl-0",
  "pl-xl-1": "IgfSgW_pl-xl-1",
  "pl-xl-10": "IgfSgW_pl-xl-10",
  "pl-xl-11": "IgfSgW_pl-xl-11",
  "pl-xl-12": "IgfSgW_pl-xl-12",
  "pl-xl-13": "IgfSgW_pl-xl-13",
  "pl-xl-14": "IgfSgW_pl-xl-14",
  "pl-xl-2": "IgfSgW_pl-xl-2",
  "pl-xl-3": "IgfSgW_pl-xl-3",
  "pl-xl-4": "IgfSgW_pl-xl-4",
  "pl-xl-5": "IgfSgW_pl-xl-5",
  "pl-xl-6": "IgfSgW_pl-xl-6",
  "pl-xl-7": "IgfSgW_pl-xl-7",
  "pl-xl-8": "IgfSgW_pl-xl-8",
  "pl-xl-9": "IgfSgW_pl-xl-9",
  "pl-xl-auto": "IgfSgW_pl-xl-auto",
  "pr-lg-0": "IgfSgW_pr-lg-0",
  "pr-lg-1": "IgfSgW_pr-lg-1",
  "pr-lg-10": "IgfSgW_pr-lg-10",
  "pr-lg-11": "IgfSgW_pr-lg-11",
  "pr-lg-12": "IgfSgW_pr-lg-12",
  "pr-lg-13": "IgfSgW_pr-lg-13",
  "pr-lg-14": "IgfSgW_pr-lg-14",
  "pr-lg-2": "IgfSgW_pr-lg-2",
  "pr-lg-3": "IgfSgW_pr-lg-3",
  "pr-lg-4": "IgfSgW_pr-lg-4",
  "pr-lg-5": "IgfSgW_pr-lg-5",
  "pr-lg-6": "IgfSgW_pr-lg-6",
  "pr-lg-7": "IgfSgW_pr-lg-7",
  "pr-lg-8": "IgfSgW_pr-lg-8",
  "pr-lg-9": "IgfSgW_pr-lg-9",
  "pr-lg-auto": "IgfSgW_pr-lg-auto",
  "pr-md-0": "IgfSgW_pr-md-0",
  "pr-md-1": "IgfSgW_pr-md-1",
  "pr-md-10": "IgfSgW_pr-md-10",
  "pr-md-11": "IgfSgW_pr-md-11",
  "pr-md-12": "IgfSgW_pr-md-12",
  "pr-md-13": "IgfSgW_pr-md-13",
  "pr-md-14": "IgfSgW_pr-md-14",
  "pr-md-2": "IgfSgW_pr-md-2",
  "pr-md-3": "IgfSgW_pr-md-3",
  "pr-md-4": "IgfSgW_pr-md-4",
  "pr-md-5": "IgfSgW_pr-md-5",
  "pr-md-6": "IgfSgW_pr-md-6",
  "pr-md-7": "IgfSgW_pr-md-7",
  "pr-md-8": "IgfSgW_pr-md-8",
  "pr-md-9": "IgfSgW_pr-md-9",
  "pr-md-auto": "IgfSgW_pr-md-auto",
  "pr-sm-0": "IgfSgW_pr-sm-0",
  "pr-sm-1": "IgfSgW_pr-sm-1",
  "pr-sm-10": "IgfSgW_pr-sm-10",
  "pr-sm-11": "IgfSgW_pr-sm-11",
  "pr-sm-12": "IgfSgW_pr-sm-12",
  "pr-sm-13": "IgfSgW_pr-sm-13",
  "pr-sm-14": "IgfSgW_pr-sm-14",
  "pr-sm-2": "IgfSgW_pr-sm-2",
  "pr-sm-3": "IgfSgW_pr-sm-3",
  "pr-sm-4": "IgfSgW_pr-sm-4",
  "pr-sm-5": "IgfSgW_pr-sm-5",
  "pr-sm-6": "IgfSgW_pr-sm-6",
  "pr-sm-7": "IgfSgW_pr-sm-7",
  "pr-sm-8": "IgfSgW_pr-sm-8",
  "pr-sm-9": "IgfSgW_pr-sm-9",
  "pr-sm-auto": "IgfSgW_pr-sm-auto",
  "pr-xl-0": "IgfSgW_pr-xl-0",
  "pr-xl-1": "IgfSgW_pr-xl-1",
  "pr-xl-10": "IgfSgW_pr-xl-10",
  "pr-xl-11": "IgfSgW_pr-xl-11",
  "pr-xl-12": "IgfSgW_pr-xl-12",
  "pr-xl-13": "IgfSgW_pr-xl-13",
  "pr-xl-14": "IgfSgW_pr-xl-14",
  "pr-xl-2": "IgfSgW_pr-xl-2",
  "pr-xl-3": "IgfSgW_pr-xl-3",
  "pr-xl-4": "IgfSgW_pr-xl-4",
  "pr-xl-5": "IgfSgW_pr-xl-5",
  "pr-xl-6": "IgfSgW_pr-xl-6",
  "pr-xl-7": "IgfSgW_pr-xl-7",
  "pr-xl-8": "IgfSgW_pr-xl-8",
  "pr-xl-9": "IgfSgW_pr-xl-9",
  "pr-xl-auto": "IgfSgW_pr-xl-auto",
  "pt-lg-0": "IgfSgW_pt-lg-0",
  "pt-lg-1": "IgfSgW_pt-lg-1",
  "pt-lg-10": "IgfSgW_pt-lg-10",
  "pt-lg-11": "IgfSgW_pt-lg-11",
  "pt-lg-12": "IgfSgW_pt-lg-12",
  "pt-lg-13": "IgfSgW_pt-lg-13",
  "pt-lg-14": "IgfSgW_pt-lg-14",
  "pt-lg-2": "IgfSgW_pt-lg-2",
  "pt-lg-3": "IgfSgW_pt-lg-3",
  "pt-lg-4": "IgfSgW_pt-lg-4",
  "pt-lg-5": "IgfSgW_pt-lg-5",
  "pt-lg-6": "IgfSgW_pt-lg-6",
  "pt-lg-7": "IgfSgW_pt-lg-7",
  "pt-lg-8": "IgfSgW_pt-lg-8",
  "pt-lg-9": "IgfSgW_pt-lg-9",
  "pt-lg-auto": "IgfSgW_pt-lg-auto",
  "pt-md-0": "IgfSgW_pt-md-0",
  "pt-md-1": "IgfSgW_pt-md-1",
  "pt-md-10": "IgfSgW_pt-md-10",
  "pt-md-11": "IgfSgW_pt-md-11",
  "pt-md-12": "IgfSgW_pt-md-12",
  "pt-md-13": "IgfSgW_pt-md-13",
  "pt-md-14": "IgfSgW_pt-md-14",
  "pt-md-2": "IgfSgW_pt-md-2",
  "pt-md-3": "IgfSgW_pt-md-3",
  "pt-md-4": "IgfSgW_pt-md-4",
  "pt-md-5": "IgfSgW_pt-md-5",
  "pt-md-6": "IgfSgW_pt-md-6",
  "pt-md-7": "IgfSgW_pt-md-7",
  "pt-md-8": "IgfSgW_pt-md-8",
  "pt-md-9": "IgfSgW_pt-md-9",
  "pt-md-auto": "IgfSgW_pt-md-auto",
  "pt-sm-0": "IgfSgW_pt-sm-0",
  "pt-sm-1": "IgfSgW_pt-sm-1",
  "pt-sm-10": "IgfSgW_pt-sm-10",
  "pt-sm-11": "IgfSgW_pt-sm-11",
  "pt-sm-12": "IgfSgW_pt-sm-12",
  "pt-sm-13": "IgfSgW_pt-sm-13",
  "pt-sm-14": "IgfSgW_pt-sm-14",
  "pt-sm-2": "IgfSgW_pt-sm-2",
  "pt-sm-3": "IgfSgW_pt-sm-3",
  "pt-sm-4": "IgfSgW_pt-sm-4",
  "pt-sm-5": "IgfSgW_pt-sm-5",
  "pt-sm-6": "IgfSgW_pt-sm-6",
  "pt-sm-7": "IgfSgW_pt-sm-7",
  "pt-sm-8": "IgfSgW_pt-sm-8",
  "pt-sm-9": "IgfSgW_pt-sm-9",
  "pt-sm-auto": "IgfSgW_pt-sm-auto",
  "pt-xl-0": "IgfSgW_pt-xl-0",
  "pt-xl-1": "IgfSgW_pt-xl-1",
  "pt-xl-10": "IgfSgW_pt-xl-10",
  "pt-xl-11": "IgfSgW_pt-xl-11",
  "pt-xl-12": "IgfSgW_pt-xl-12",
  "pt-xl-13": "IgfSgW_pt-xl-13",
  "pt-xl-14": "IgfSgW_pt-xl-14",
  "pt-xl-2": "IgfSgW_pt-xl-2",
  "pt-xl-3": "IgfSgW_pt-xl-3",
  "pt-xl-4": "IgfSgW_pt-xl-4",
  "pt-xl-5": "IgfSgW_pt-xl-5",
  "pt-xl-6": "IgfSgW_pt-xl-6",
  "pt-xl-7": "IgfSgW_pt-xl-7",
  "pt-xl-8": "IgfSgW_pt-xl-8",
  "pt-xl-9": "IgfSgW_pt-xl-9",
  "pt-xl-auto": "IgfSgW_pt-xl-auto",
});
